import styled, { css } from 'styled-components';
import { usePortal, useTranslation } from '../../hooks/useNavConfig';
import { MenuItem } from '../Menu';
import { getFullUrl } from 'hubspot-url-utils';
// @ts-expect-error bender imports are untyped
import defaultAvatar from 'bender-url!../../../img/default-avatar.png';
import { ButtonWithDemoExitConfirmation } from '../DemoExitConfirmation/ButtonWithDemoExitConfirmation';
import { getTypographyStyles } from '../../nav-ui-components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UserPrefTextContainer = styled.div.withConfig({
  displayName: "UserPreferences__UserPrefTextContainer",
  componentId: "mt8vla-0"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return css(["padding-left:60px !important;margin-top:", " !important;margin-bottom:", " !important;"], theme.space['200'], theme.space['200']);
});
const UserAvatar = styled.img.withConfig({
  displayName: "UserPreferences__UserAvatar",
  componentId: "mt8vla-1"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return css(["width:48px;height:48px;left:", ";top:", ";position:absolute;margin:", " !important;border-radius:50%;"], theme.space['400'], theme.space['400'], theme.space['0']);
});
const UserName = styled.div.withConfig({
  displayName: "UserPreferences__UserName",
  componentId: "mt8vla-2"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return css(["color:", " !important;white-space:pre-wrap;overflow-wrap:break-word;text-decoration:none !important;", ":hover{text-decoration:none !important;}"], theme.color['text-primary-default'], getTypographyStyles(theme, 'heading-100'));
});
const UserEmail = styled.div.withConfig({
  displayName: "UserPreferences__UserEmail",
  componentId: "mt8vla-3"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return css(["color:", " !important;white-space:pre-wrap;overflow-wrap:break-word;text-decoration:none !important;", ":hover{text-decoration:none !important;}"], theme.color['text-primary-default'], getTypographyStyles(theme, 'body-100'));
});
const UserLink = styled.div.withConfig({
  displayName: "UserPreferences__UserLink",
  componentId: "mt8vla-4"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return css(["color:", " !important;", " text-decoration:none !important;cursor:pointer !important;display:inline-block !important;:hover{text-decoration:underline !important;}"], theme.color['text-interactive-default'], getTypographyStyles(theme, 'body-125'));
});
const StyledMenuItem = styled(MenuItem)(({
  theme: _theme
}) => {
  const theme = _theme;
  return css(["list-style-type:none !important;display:block;position:relative;color:", " !important;border-bottom:", " solid ", " !important;min-height:80px;padding:", " ", " !important;:hover ", "{text-decoration:underline !important;}"], theme.color['text-primary-default'], theme.borderWidth['100'], theme.color['border-primary-default'], theme.space['200'], theme.space['400'], UserLink);
});
const UserPreferences = ({
  avatarUrl,
  userName,
  userEmail
}) => {
  const {
    t
  } = useTranslation();
  const {
    portalId
  } = usePortal();
  const imgSrc = encodeURI(avatarUrl);
  const preferencesText = t('nav.tools.profileAndPreferences');
  const href = `${getFullUrl('app')}/user-preferences/${portalId || ''}`;
  return /*#__PURE__*/_jsxs(ButtonWithDemoExitConfirmation, {
    component: StyledMenuItem,
    id: "userPreferences",
    href: href,
    "data-test-id": "nav-account-menu-user-preferences",
    style: {
      textDecoration: 'none'
    },
    children: [/*#__PURE__*/_jsx(UserAvatar, {
      alt: userName,
      src: imgSrc || defaultAvatar,
      "aria-hidden": "true"
    }), /*#__PURE__*/_jsxs(UserPrefTextContainer, {
      children: [/*#__PURE__*/_jsx(UserName, {
        children: userName
      }), /*#__PURE__*/_jsx(UserEmail, {
        children: userEmail
      }), /*#__PURE__*/_jsx(UserLink, {
        children: preferencesText
      })]
    })]
  });
};
export default UserPreferences;